/* eslint-disable no-unused-vars */
import { FormField, FormFieldType } from './formField'

/**
 * Creates an instance of ContentField.
 * @typedef {Object} ContentFieldType
 * @property {string} html - A string containing html content
 *
 * @typedef {FormFieldType & ContentFieldType} ContentFieldExtendType
 */

/**
 * Represents a content field.
 * @class
 */
export class ContentField extends FormField {
  /**
   * Create a new ContentField.
   * @param {ContentFieldExtendType} params
   */
  constructor(params) {
    super(params)
    this.html = params.html
  }
}
